import DataSource from 'devextreme/data/data_source';

export class BdsCustomerSearchDialogModel {
    title?: string;
    actionText: string;
    dismissiveText = 'Cancel';
    defaultFastracName = 'SEARCH CONSIGNEE';
    source?: DataSource;
}
